
import { useMemo } from "react";
import { GameContainer } from "../board/GameContainer";
import { GameContent } from "../board/GameContent";
import type { DailyPuzzle } from "@/lib/types/game";
import type { Word, LogicRule } from "@/lib/game-utils";

interface GamePlayScreenProps {
  puzzle: DailyPuzzle;
  onComplete: (
    result: "perfect" | "wrong",
    solveTime: number,
    selectedWords: Array<{ word: Word; order: number }>,
    selectedRule: LogicRule,
    rules: LogicRule[]
  ) => void;
  isReplay?: boolean;
  externalDataUrl?: string;
}

export function GamePlayScreen({
  puzzle,
  onComplete,
  isReplay = false,
  externalDataUrl
}: GamePlayScreenProps) {
  const { words, correctOrder, correctRule, logicRules } = useMemo(
    () => puzzle,
    [puzzle]
  );

  return (
    <GameContainer
      words={words}
      logicRules={[correctRule]} // Only pass the correct rule
      targetOrder={correctOrder}
      targetRule={correctRule}
      onComplete={onComplete}
      isReplay={isReplay}
      externalDataUrl={externalDataUrl}
    />
  );
}
